export default __webpack_public_path__ + "static/media/img-0751-romania-premium-face.f15e1277.png";